<template>
  <v-container fluid id="faq-page">
    <v-row class="ml-16">
      <v-col cols="11" md="7">
        <h1 id="title">
          Frequently<br />
          Asked Questions
        </h1>
      </v-col>
    </v-row>
    <v-row align="center" justify="center">
      <v-expansion-panels v-model="panel" class="mt-5">
        <v-col cols="10" md="5">
          <v-expansion-panel ref="panel1" class="expansion-panel">
            <v-expansion-panel-header class="card-title"
              ><v-col cols="10">When is the official launch?</v-col>
              <template v-slot:actions>
                <v-btn
                  v-if="panel == 0"
                  :ripple="false"
                  class="btn-active"
                  fab
                  depressed
                  small
                  color="#D9AD59"
                >
                  <v-icon color="white"> mdi-plus mdi-rotate-45</v-icon>
                </v-btn>
                <v-btn
                  v-else
                  :ripple="false"
                  class="mx-2 btn-passive"
                  fab
                  depressed
                  small
                  color="white"
                >
                  <v-icon color="#D9AD59"> mdi-plus </v-icon>
                </v-btn>
              </template></v-expansion-panel-header
            >
            <v-expansion-panel-content class="expansion-panel-text">
              <v-col cols="10">
                We are committed to support, invest, reward, and collaborate
                with the best projects in the space and projects ideas of our
                members.
              </v-col>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-col>
        <v-col cols="10" md="5">
          <v-expansion-panel ref="panel2" class="expansion-panel">
            <v-expansion-panel-header class="card-title"
              ><v-col cols="10">What will be the price?</v-col>
              <template v-slot:actions>
                <v-btn
                  v-if="panel == 1"
                  :ripple="false"
                  class="btn-active"
                  fab
                  depressed
                  small
                  color="#D9AD59"
                >
                  <v-icon color="white"> mdi-plus mdi-rotate-45</v-icon>
                </v-btn>
                <v-btn
                  v-else
                  :ripple="false"
                  class="mx-2"
                  fab
                  depressed
                  small
                  color="white"
                >
                  <v-icon color="#D9AD59"> mdi-plus </v-icon>
                </v-btn>
              </template></v-expansion-panel-header
            >
            <v-expansion-panel-content class="expansion-panel-text">
              <v-col cols="10">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla
                sed lacus sit amet sem aliquet semper consectetur adipiscing.
              </v-col>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-col>
        <v-col cols="10" md="5">
          <v-expansion-panel ref="panel5" class="expansion-panel">
            <v-expansion-panel-header class="card-title"
              ><v-col cols="10">How do I get whitelisted?</v-col>
              <template v-slot:actions>
                <v-btn
                  v-if="panel == 2"
                  :ripple="false"
                  class="btn-active"
                  fab
                  depressed
                  small
                  color="#D9AD59"
                >
                  <v-icon color="white"> mdi-plus mdi-rotate-45</v-icon>
                </v-btn>
                <v-btn
                  v-else
                  :ripple="false"
                  class="mx-2"
                  fab
                  depressed
                  small
                  color="white"
                >
                  <v-icon color="#D9AD59"> mdi-plus </v-icon>
                </v-btn>
              </template></v-expansion-panel-header
            >
            <v-expansion-panel-content class="expansion-panel-text">
              <v-col cols="10">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla
                sed lacus sit amet sem aliquet semper consectetur adipiscing.
              </v-col>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-col>
        <v-col cols="10" md="5">
          <v-expansion-panel ref="panel4" class="expansion-panel">
            <v-expansion-panel-header class="card-title"
              ><v-col cols="10">How can I buy a KittyClub NFT?</v-col>
              <template v-slot:actions>
                <v-btn
                  v-if="panel == 3"
                  :ripple="false"
                  class="btn-active"
                  fab
                  depressed
                  small
                  color="#D9AD59"
                >
                  <v-icon color="white"> mdi-plus mdi-rotate-45</v-icon>
                </v-btn>
                <v-btn
                  v-else
                  :ripple="false"
                  class="mx-2"
                  fab
                  depressed
                  small
                  color="white"
                >
                  <v-icon color="#D9AD59"> mdi-plus </v-icon>
                </v-btn>
              </template></v-expansion-panel-header
            >
            <v-expansion-panel-content class="expansion-panel-text">
              <v-col cols="10">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla
                sed lacus sit amet sem aliquet semper consectetur adipiscing.
              </v-col>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-col>
        <v-col cols="10" md="5">
          <v-expansion-panel ref="panel7" class="expansion-panel">
            <v-expansion-panel-header class="card-title"
              ><v-col cols="10">Where will I be able to see my NFT?</v-col>
              <template v-slot:actions>
                <v-btn
                  v-if="panel == 4"
                  :ripple="false"
                  class="btn-active"
                  fab
                  depressed
                  small
                  color="#D9AD59"
                >
                  <v-icon color="white"> mdi-plus mdi-rotate-45</v-icon>
                </v-btn>
                <v-btn
                  v-else
                  :ripple="false"
                  class="mx-2"
                  fab
                  depressed
                  small
                  color="white"
                >
                  <v-icon color="#D9AD59"> mdi-plus </v-icon>
                </v-btn>
              </template></v-expansion-panel-header
            >
            <v-expansion-panel-content class="expansion-panel-text">
              <v-col cols="10">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla
                sed lacus sit amet sem aliquet semper consectetur adipiscing.
              </v-col>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-col>
        <v-col cols="10" md="5">
          <v-expansion-panel ref="panel6" class="expansion-panel">
            <v-expansion-panel-header class="card-title"
              ><v-col cols="10">Why Kitty Club?</v-col>
              <template v-slot:actions>
                <v-btn
                  v-if="panel == 5"
                  :ripple="false"
                  class="btn-active"
                  fab
                  depressed
                  small
                  color="#D9AD59"
                >
                  <v-icon color="white"> mdi-plus mdi-rotate-45</v-icon>
                </v-btn>
                <v-btn
                  v-else
                  :ripple="false"
                  class="mx-2"
                  fab
                  depressed
                  small
                  color="white"
                >
                  <v-icon color="#D9AD59"> mdi-plus </v-icon>
                </v-btn>
              </template></v-expansion-panel-header
            >
            <v-expansion-panel-content class="expansion-panel-text">
              <v-col cols="10">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla
                sed lacus sit amet sem aliquet semper consectetur adipiscing.
              </v-col>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-col>
        <v-col cols="10" md="5"> </v-col>
        <v-col cols="10" md="5">
          <v-expansion-panel ref="panel8" class="expansion-panel">
            <v-expansion-panel-header class="card-title"
              ><v-col cols="10">What will be the price?</v-col>
              <template v-slot:actions>
                <v-btn
                  v-if="panel == 6"
                  :ripple="false"
                  class="btn-active"
                  fab
                  depressed
                  small
                  color="#D9AD59"
                >
                  <v-icon color="white"> mdi-plus mdi-rotate-45</v-icon>
                </v-btn>
                <v-btn
                  v-else
                  :ripple="false"
                  class="mx-2"
                  fab
                  depressed
                  small
                  color="white"
                >
                  <v-icon color="#D9AD59"> mdi-plus </v-icon>
                </v-btn>
              </template></v-expansion-panel-header
            >

            <v-expansion-panel-content class="expansion-panel-text">
              <v-col cols="10">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla
                sed lacus sit amet sem aliquet semper consectetur adipiscing.
              </v-col>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-col>
      </v-expansion-panels>

      <a href="#" class="glow-button mt-12 mb-12"
        ><v-icon large color="#FFFFFF" class="mr-2">mdi-discord</v-icon>Join our
        discord</a
      >
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "FAQ",

  data() {
    return {
      panel: 0,
    };
  },
};
</script>
<style>
.btn-active {
  height: 120px !important;
  width: 40px !important;
  border-radius: 50px !important;
  position: absolute;
  margin-top: -3% !important;
  margin-left: -8% !important;
}
.btn-passive {
  transition: 0.25s;
}
@media screen and (max-width: 500px) {
  .btn-active {
    height: 170px !important;
    margin-left: -9% !important;
  }
}
</style>
<style scoped>
.expansion-panel-text {
  font-size: 13px;
}
.card-title {
  text-transform: uppercase;
  font-weight: 700;
}
.expansion-panel {
  border-radius: 50px;
  background: #000000 !important;
  color: #ffffff !important;
  border-radius: 50px !important;
  border: 1px solid white;
  margin-top: -15px;
  position: relative;
}
.glow-button {
  text-decoration: none;
  color: white !important;
  background: linear-gradient(
    135deg,
    rgba(217, 173, 89, 1) 0%,
    rgba(162, 128, 62, 1) 100%
  );
  padding: 15px 40px;
  border-radius: 4px;
  font-weight: normal;
  box-shadow: 0 0 15px rgb(255, 255, 255, 0.4) !important;
  font-size: 2vw !important;
  cursor: pointer;
}
#title {
  color: white !important;
  font-weight: 500 !important;
  font-size: 5vw !important;
  line-height: 5vw !important;
}
.card {
}
#faq-page {
  color: white;
  background: #000000;
  position: relative;
  background: url(../assets/bg-faq.png) no-repeat center center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  overflow: hidden;
}
@media screen and (max-width: 821px) {
  #title {
    margin-top: 20px;
    margin-left: -50px !important;
    font-size: 8vw !important;
    line-height: 9vw !important;
  }
  .glow-button {
    font-size: 4vw !important;
    margin-bottom: 20px !important;
  }
}
@media screen and (max-width: 600px) {
  #faq-page {
    height: initial;
  }
}
@media screen and (max-width: 376px) {
  #title {
    font-size: 8vw !important;
    line-height: 8vw !important;
  }
}
@media screen and (max-width: 361px) {
  #title {
    font-size: 10vw !important;
    line-height: 10vw !important;
  }
}
</style>
